// Klaviyo Discount Code Integration (apply via cart/update.js)
class KlaviyoDiscountHandler {
    constructor() {
      this.isApplyingDiscount = false;
      this.lastAppliedCode = null;
      this.init();
    }
  
    init() {
      // Listen for cart events to apply discount when cart opens/changes
      this.copyBtnClick();
    }
    copyBtnClick(){
      document.addEventListener('click', (e) => {
        if (e.target.closest('button[aria-label="Copy coupon code"]')) {
          const button = e.target.closest('button[aria-label="Copy coupon code"]');
          // Find the div containing the coupon code
          const codeDiv = button.querySelector('div');
          const code = codeDiv ? codeDiv.textContent.trim() : null;
          if(code){
            this.applyDiscountToCart(code);
          }
        }
      });
    }
  
   
  
    applyDiscountToCart(code) {
      if (this.isApplyingDiscount) {
        return; // Prevent multiple simultaneous requests
      }
      
      this.isApplyingDiscount = true;
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
           body: JSON.stringify({ discount: code })

      })
      .then(res => res.json())
      .then(data => {
        this.lastAppliedCode = code;
         window.upcartRefreshCart();

        
        // Only trigger cart reload if we're not already in a cart update cycle
        if (!this.isApplyingDiscount) {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
          
        }

      })
      .catch(err => {
        console.error("Error applying discount:", err);
      })
      .finally(() => {
        this.isApplyingDiscount = false;
      });
    }
  }
  
  // Init
  document.addEventListener('DOMContentLoaded', () => {
    new KlaviyoDiscountHandler();
  });
  